module.exports = __webpack_public_path__ + "img/carouselBg.c95350c0.png";